import React, { useState,useEffect,Suspense,useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import { Tabs, Tab } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { startOfDay, differenceInDays, format } from 'date-fns'; // Add these imports
import { utcToZonedTime } from 'date-fns-tz'; // For timezone handling if needed
import { debounce } from 'lodash'; // Or implement your own debounce function
import { useNotification } from "../../context/NotificationContext";

import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import generateInvoice from "./invoices/frontOffice"; // Import the Invoice component
import ReactDOM from "react-dom"; // ✅ Import ReactDOM
import { pdf } from "@react-pdf/renderer"; // ✅ Ensure this is imported
import { Modal, Button, Spinner } from "react-bootstrap";
import CryptoJS from "crypto-js";
import html2pdf from 'html2pdf.js';
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import axios from "axios";
import { Dropdown } from "react-bootstrap";
import { useGlobalData } from "../../context/GlobalDataContext";
import Swal from "sweetalert2"; // ✅ Import SweetAlert
import AddPaymentPopup from './components/popups/AddPaymentPopup'; // Adjust path as needed
import AddChargePopup from './components/popups/AddChargePopup'; // Adjust path as needed
import BookingPriceUpdatePopup from './components/popups/BookingPriceUpdatePopup'; // Adjust path as needed
import PartnerService from "./utils/partnerService";

import InvoicePreview from "./components/popups/InvoicePreview"; // Adjust the path as needed
import RegistrationCardPreview from "./components/popups/RegcardPreview"; // New import
import generateRegistrationCard from "./invoices/registrationCard"; // Adjust the path as needed
import generateConfirmation  from "./invoices/generateConfirmation"; // Adjust path as needed
import { 
  User,
  Users,
  Calendar,
  Percent,
  Move,
  Home,
  XCircle,
  CheckCircle,
  AlertCircle,
  Mail,
  FileText,
  Printer,
  PlusCircle,
  Edit,
  Sliders,
  DollarSign,
  Camera, UploadCloud, 
  PauseCircle,
  LogIn,
  UserCheck,
  ChevronRight,
  BookOpen as Logs,
  LogOut,
  MapPin,
  Tag,
  Heart,
  CreditCard,
  RefreshCw,
  MessageSquare,
  Loader as SpinnerIcon
} from 'react-feather';


import UpdateCheckoutPopup from "./components/popups/UpdateCheckOutPopup"; // A
import UpdateGuestInfoPopup from "./components/popups/UpdateGuestInfoPopup"; // A
import UpdateGuestCountPopup from "./components/popups/UpdateGuestCountPopup"; // A
import MoveRoomPopup from "./components/popups/MoveRoomPopup"; // A
import MoveRoomPopupAll from "./components/popups/MoveRoomPopupAll"; // A

import FolioPreview from "./components/popups/FolioPreview"; // Add this import at the top
import { renderDate } from "./utils/dateFormatter";


const GuestCheckInOut = () => {
  const [key, setKey] = useState("folio");
  const [isGenerating, setIsGenerating] = useState(false); // Track loading state
  const [selectedFile, setSelectedFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showRegModal, setShowRegModal] = useState(false);
  const [regHtmlContent, setRegHtmlContent] = useState(null); // New state for registration card HTML
  const [pdfUrl, setPdfUrl] = useState("");
  const secretKey = "abde100199199111";
  const [regOutputType, setRegOutputType] = useState("html");
	const [confHtmlContent, setConfHtmlContent] = useState(null); // New state for confirmation card HTML
	const [confOutputType, setConfOutputType] = useState("html"); // New state for confirmation card output type
	const [showConfModal, setShowConfModal] = useState(false); // New state for confirmation card modal
	const [showFolioModal, setShowFolioModal] = useState(false); // Controls Folio modal visibility
const [folioOutputType, setFolioOutputType] = useState("html"); // Tracks Folio output type (html/pdf)
  const [reservation, setReservation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [previewLoading, setPreviewLoading] = useState(false); // For modal preview loading
  const [error, setError] = useState(null);
  const [guestDetails, setGuestDetails] = useState(null);
  const [paymentSummary, setPaymentSummary] = useState(null);
  const [refundCase, setRefundCase] = useState(null);
  const [refundCaseLoading, setRefundCaseLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  //const { business_date } = useGlobalData();
  const business_date = localStorage.getItem("business_date"); // e.g., "2025-02-23"
  const [showAddPayment, setShowAddPayment] = useState(false);
  const [folioRefreshKey, setFolioRefreshKey] = useState(0); // Add state to trigger Folio re-render
  const GuestAccommodationDetails = React.lazy(() =>
    import("./components/reservations/GuestAccommodationDetails")
  );
  const GuestDetails = React.lazy(() => import("./components/reservations/GuestDetails"));
  const GuestActivityHistory = React.lazy(() => import("./components/reservations/UserActivityDetails"));

    const { getPartnerName } = PartnerService();

  const GuestFolio = React.lazy(() => import("./components/reservations/GuestFolio"));

  const [showAddCharge, setShowAddCharge] = useState(false); // New state for AddCharge popup
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const { notify } = useNotification();

  const [htmlContent, setHtmlContent] = useState(null);
  const [outputType, setOutputType] = useState("pdf");

  const [activityRefreshKey, setActivityRefreshKey] = useState(0);
// Update handleAddCharge function
const handleAddCharge = () => {
  setShowAddCharge(true);
};


const handleTabSelect = (k) => {
    setKey(k);
    if (k === "activityDetails") {
      setActivityRefreshKey((prev) => prev + 1); // Trigger refresh for Activity Details tab
    }
  };

// Update handleAddCharge function
const handleAddPayment = () => {
  setShowAddPayment(true);
};


const handleBalanceDueUpdate = useCallback((balanceDue) => {
  setGuestDetails((prev) => {
    // Avoid unnecessary state updates if balance_due hasn't changed
    if (prev.balance_due === balanceDue) {
      return prev;
    }
    return {
      ...prev,
      balance_due: balanceDue,
    };
  });
}, []); // No dependencies, as setGuestDetails is stable


const handlePrintFolio = async (initialOutputType = "html") => {
    try {
      const bookingId = guestDetails?.booking_id;
      if (!bookingId) {
        throw new Error("Booking ID is required to generate Folio.");
      }
      console.log("Opening folio modal with outputType:", initialOutputType);
      setShowFolioModal(true);
      setFolioOutputType(initialOutputType);
    } catch (error) {
      console.error("Folio Error:", error);
      Swal.fire({
        title: "Error Generating Folio!",
        text: error.message || "An error occurred while generating the Folio.",
        icon: "error",
      });
    }
  };

const handleSwitchFolioView = (newOutputType) => {
    console.log("Switching folio view to:", newOutputType);
    setFolioOutputType(newOutputType);
  };
const handleEmailFolio = async () => {
    try {
      const bookingId = guestDetails?.booking_id;
      if (!bookingId) {
        throw new Error("Booking ID is required to email Folio.");
      }
      console.log("Emailing folio for bookingId:", bookingId);
      // Add email logic if needed, or pass to FolioPreview
    } catch (error) {
      console.error("Email Folio Error:", error);
      Swal.fire({
        title: "Error!",
        text: error.message || "Failed to email the Folio.",
        icon: "error",
      });
    }
  };

const handleCloseFolioModal = () => {
  setShowFolioModal(false);
  if (pdfUrl) {
    URL.revokeObjectURL(pdfUrl);
    setPdfUrl("");
  }
  // htmlContent reset handled in FolioPreview
};



  const Loader = () => (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
      <SpinnerIcon size={24} className="me-2" />
      <span>Loading...</span>
    </div>
  );

  const decryptId = (encryptedId) => {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedId, secretKey);
      const originalId = bytes.toString(CryptoJS.enc.Utf8);
      if (!originalId) throw new Error("Invalid decryption");
      return originalId;
    } catch (error) {
      console.error("Decryption error:", error.message);
      return null;
    }
  };

  const { id } = useParams();
  const reservationId = decryptId(id);

// Handle Mark No Show
const handleMarkNoShow = () => {
  Swal.fire({
    title: 'Mark as No Show?',
    text: "Are you sure you want to mark this booking as No Show?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, mark it!',
    cancelButtonText: 'No, cancel',
  }).then((result) => {
    if (result.isConfirmed) {
      // Implement API call to update bookingStatus to "noshow"
      axios.post(
        `${apiUrl}/booking/mark-no-show`,
        { bookingId: reservationId },
        { headers: { Authorization: `Bearer ${token}` } }
      ).then(() => {
        notify("success","Booking marked as No Show successfully!");
        setGuestDetails((prev) => ({
          ...prev,
          bookingStatus: "noshow", // Update the booking status to "noshow"
        }));
      }).catch((error) => {
        notify("error","Failed to mark as No Show. Please try again.");
        console.error("Error marking as No Show:", error);
      });
    }
  });
};

// Handle Remove No Show (Restore Booking)
const handleRemoveNoShow = () => {
  Swal.fire({
    title: 'Restore Booking?',
    text: "Are you sure you want to restore this booking?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, restore it!',
    cancelButtonText: 'No, cancel',
  }).then((result) => {
    if (result.isConfirmed) {
      // Implement API call to update bookingStatus to "reserved" or "confirmed"
      axios.post(
        `${apiUrl}/booking/restore-booking`,
        { bookingId: reservationId },
        { headers: { Authorization: `Bearer ${token}` } }
      ).then(() => {
        notify("success","Booking restored successfully!");
        //fetchReservationDetails();
      }).catch((error) => {
        notify("error","Failed to restore booking. Please try again.");
        console.error("Error restoring booking:", error);
      });
    }
  });
};

const handleCloseProformaModal = () => {
  setShowModal(false);
  if (pdfUrl) {
    URL.revokeObjectURL(pdfUrl);
    setPdfUrl("");
  }
  setHtmlContent(null);
};

const handlePaymentSubmit = (paymentData) => {

  //alert(JSON.stringify(paymentData));
  // Ensure paymentAmount is a valid number
  const paymentAmount = paymentData.totalAmount ? parseFloat(paymentData.totalAmount) : 0;
  if (isNaN(paymentAmount) || paymentAmount <= 0) {
    notify("error","Invalid payment amount. Please try again.");
    return;
  }

  // Reduce balance_due by the payment amount, ensuring it’s a number and doesn’t go negative
  setGuestDetails((prev) => {
    const currentBalance = parseFloat(prev.balance_due) || 0;
    const newBalance = Math.max(0, currentBalance - paymentAmount);
    return {
      ...prev,
      balance_due: newBalance,
    };
  });

  // Trigger Folio tab refresh by incrementing folioRefreshKey
  setFolioRefreshKey((prev) => prev + 1);

};


// Handle charge submission from AddChargePopup, including tax amount
const handleChargeSubmit = (chargeData) => {
  // Update balance_due in guestDetails with the total amount (amount + taxAmount)
  const newBalanceDue = (guestDetails?.balance_due || 0) + (chargeData.totalAmount || 0);
  setGuestDetails((prev) => ({
    ...prev,
    balance_due: newBalanceDue, // Update balance_due with the total charge (amount + tax)
  }));

  // Trigger Folio tab refresh by incrementing folioRefreshKey
  setFolioRefreshKey((prev) => prev + 1);

  // Close the popup
  setShowAddCharge(false);
};

  const handleDeleteReservation = async () => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to cancel the reservation for ${guestDetails?.name}. This action cannot be undone!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Cancel it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Show loading while processing
          Swal.fire({
            title: 'Cancel Reservation...',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
  
          // Call the cancel-reservation API
          const response = await axios.post(
            `${apiUrl}/booking/cancel-reservation`,
            {
              bookingId: guestDetails?.booking_id
            },
            { headers: { Authorization: `Bearer ${token}` } }
          );
  
          if (response.status === 200) {
            Swal.fire({
              title: 'Cancel Reservation!',
              text: `${guestDetails?.name}'s reservation has been cancelled.`,
              icon: 'success'
            }).then(() => {

              // Update the guestDetails state to reflect the cancelled status
          setGuestDetails((prev) => ({
            ...prev,
            bookingStatus: "cancelled", // Update the booking status to "cancelled"
          }));

            });
          } else {
            throw new Error("Failed to delete reservation");
          }
        } catch (error) {
          console.error("Deletion Error:", error);
  
          // Show API error message if available
          const errorMessage = error.response?.data?.message || "An error occurred while deleting the reservation.";
          
          Swal.fire({
            title: 'Error!',
            text: errorMessage,
            icon: 'error'
          });
        }
      }
    });
  };


  const handlePrintRegistrationCard = debounce(async (initialOutputType = "html") => {
    try {
      const bookingId = guestDetails?.booking_id;
      if (!bookingId) {
        throw new Error("Booking ID is required to generate Registration Card.");
      }

      setPreviewLoading(true);
      setShowRegModal(true);

      const result = await generateRegistrationCard(bookingId, "preview", initialOutputType);

      if (initialOutputType === "html") {
        setRegHtmlContent(result);
        if (pdfUrl) {
          URL.revokeObjectURL(pdfUrl);
        }
        setPdfUrl("");
      } else {
        if (!(result instanceof Blob)) {
          throw new Error("Generated Registration Card is not a valid Blob.");
        }
        const generatedPdfUrl = URL.createObjectURL(result);
        setPdfUrl(generatedPdfUrl);
        setRegHtmlContent(null);
      }

      setRegOutputType(initialOutputType);
    } catch (error) {
      console.error("Registration Card Error:", error);
      Swal.fire({
        title: "Error Generating Registration Card!",
        text: error.message || "An error occurred while generating the Registration Card.",
        icon: "error",
      });
      setShowRegModal(false);
    } finally {
      setPreviewLoading(false);
    }
  }, 300);

  const handleSwitchRegistrationCardView = async (newOutputType) => {
    try {
      setPreviewLoading(true);
      const bookingId = guestDetails?.booking_id;
      if (!bookingId) {
        throw new Error("Booking ID is required to switch Registration Card view.");
      }

      const result = await generateRegistrationCard(bookingId, "preview", newOutputType);

      if (newOutputType === "html") {
        setRegHtmlContent(result);
        if (pdfUrl) {
          URL.revokeObjectURL(pdfUrl);
        }
        setPdfUrl("");
      } else {
        if (!(result instanceof Blob)) {
          throw new Error("Generated Registration Card is not a valid Blob.");
        }
        const generatedPdfUrl = URL.createObjectURL(result);
        setPdfUrl(generatedPdfUrl);
        setRegHtmlContent(null);
      }

      setRegOutputType(newOutputType);
      //toast.success(`Switched to ${newOutputType.toUpperCase()} view!`, { autoClose: 2000 });
    } catch (error) {
      console.error("Error switching registration card view:", error);
      Swal.fire({
        title: "Error Switching View!",
        text: error.message || "An error occurred while switching the view.",
        icon: "error",
      });
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleEmailRegistrationCard = async () => {
    try {
      const bookingId = guestDetails?.booking_id;
      if (!bookingId) {
        throw new Error("Booking ID is required to email Registration Card.");
      }

      const result = await generateRegistrationCard(bookingId, "email");
      return result;
    } catch (error) {
      console.error("Error emailing registration card:", error);
      throw new Error(error.message || "Failed to email the Registration Card.");
    }
  };

  const handleCloseRegModal = () => {
    setShowRegModal(false);
    if (pdfUrl) {
      URL.revokeObjectURL(pdfUrl);
      setPdfUrl("");
    }
    setRegHtmlContent(null);
  };
  // Handle closing the modal and cleaning up the PDF URL


// src/GuestCheckInOut.js
const handlePrintProformaInvoice = debounce(async (initialOutputType = "html") => {
    try {
      const bookingId = guestDetails?.booking_id;
      if (!bookingId) {
        throw new Error("Booking ID is required to generate Proforma Invoice.");
      }

      setPreviewLoading(true);
      setShowModal(true);

      const result = await generateInvoice({ bookingId }, "proforma", "preview", initialOutputType);

      if (initialOutputType === "html") {
        setHtmlContent(result);
        if (pdfUrl) {
          URL.revokeObjectURL(pdfUrl);
        }
        setPdfUrl("");
      } else {
        if (!(result instanceof Blob)) {
          throw new Error("Generated Proforma Invoice is not a valid Blob.");
        }
        const generatedPdfUrl = URL.createObjectURL(result);
        setPdfUrl(generatedPdfUrl);
        setHtmlContent(null);
      }

      setOutputType(initialOutputType);
     // notify("success","Proforma Invoice loaded successfully!", { autoClose: 2000 });
    } catch (error) {
      console.error("Proforma Invoice Error:", error);
      Swal.fire({
        title: "Error Generating Proforma Invoice!",
        text: error.message || "An error occurred while generating the Proforma Invoice.",
        icon: "error",
      });
      setShowModal(false);
    } finally {
      setPreviewLoading(false);
    }
  }, 300);

  const handleSwitchView = async (newOutputType) => {
    try {
      setPreviewLoading(true);
      const bookingId = guestDetails?.booking_id;
      if (!bookingId) {
        throw new Error("Booking ID is required to switch Proforma Invoice view.");
      }

      const result = await generateInvoice({ bookingId }, "proforma", "preview", newOutputType);
      
      if (newOutputType === "html") {
        setHtmlContent(result);
        if (pdfUrl) {
          URL.revokeObjectURL(pdfUrl);
        }
        setPdfUrl("");
      } else {
        if (!(result instanceof Blob)) {
          throw new Error("Generated Proforma Invoice is not a valid Blob.");
        }
        const generatedPdfUrl = URL.createObjectURL(result);
        setPdfUrl(generatedPdfUrl);
        setHtmlContent(null);
      }

      setOutputType(newOutputType);
      //toast.success(`Switched to ${newOutputType.toUpperCase()} view!`, { autoClose: 2000 });
    } catch (error) {
      console.error("Error switching proforma invoice view:", error);
      Swal.fire({
        title: "Error Switching View!",
        text: error.message || "An error occurred while switching the view.",
        icon: "error",
      });
    } finally {
      setPreviewLoading(false);
    }
  };


useEffect(() => {
  const fetchReservationDetails = async () => {
    try {
      const response = await axios.get(`${apiUrl}/booking/details/${reservationId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const booking = response.data.booking;
      const guestInfo = booking.guest || {
        full_name: "N/A",
        guest_title: "N/A",
        email: "N/A",
        phone_no: "N/A",
        gender: "N/A",
        nationality: "N/A",
        id_proof_type: "N/A",
        id_proof_number: "N/A",
        is_authenticated: false
      };

      // Store raw dates as ISO strings
      const rawCheckIn = booking.check_in_date;
      const rawCheckOut = booking.check_out_date;
      const rawReservationDate = booking.created_at || new Date().toISOString();

      // Normalize for calculations
      const normalizedCheckIn = startOfDay(new Date(rawCheckIn));
      const normalizedCheckOut = startOfDay(new Date(rawCheckOut));
      const guestDetails = {
        name: booking.guest.name || "N/A",
        guest_id:booking.guest.guest_id || "N/A",
        title: booking.guest.title || "N/A",
        email: booking.guest.email || "N/A",
        phone: booking.guest.phone || "N/A",
        gender: booking.guest.gender || "N/A",
        gst_number: booking.guest.gst_number || "N/A",
        gst_company_name: booking.guest.gst_company_name || "N/A",
        gst_company_address: booking.guest.gst_company_address || "N/A",
        expected_time: booking.expected_time || "N/A",
        nationality: booking.guest.nationality || "N/A",
        additional_notes: booking.guest.additional_notes || "N/A",        	
        visit_purpose: booking.visit_purpose || "",
        arrival_from: booking.arrival_from || "",
        travelling_with_pet:
          typeof booking.travelling_with_pet === "boolean"
            ? booking.travelling_with_pet
            : null,
        previous_stays: Number(booking.previous_stays) || 0,
        last_stay_date: booking.last_stay_date || null,
        total_paid: Number(booking.total_paid) || 0,
        payment_status: booking.payment_status || "pending",
        idProofType: booking.guest.id_proof_type || "N/A",
        idProofNumber: guestInfo.id_proof_number || "N/A",
        isAuthenticated: guestInfo.is_authenticated || false,
        roomNumber: booking.rooms[0]?.room_number || "N/A",
        checkIn: rawCheckIn, // Store as ISO string
        checkOut: rawCheckOut, // Store as ISO string
        reservationDate: rawReservationDate, // Store as ISO string
        bookingNumber: booking.booking_number || "N/A",
        bookingStatus: booking.booking_status || "N/A",
        reservationType: booking.reservation_type || "N/A",
        bookingSource: booking.booking_source || "N/A",
        arrivalTime: booking.guest.expected_time || "N/A",
        booking_id: booking.booking_id || "N/A",
        balance_due: booking.balance_due || "0.00",
        roomType: booking.rooms[0]?.room_type || "N/A",
        nights: differenceInDays(normalizedCheckOut, normalizedCheckIn),
        guests: {
          adults: booking.num_adults || 0,
          children: booking.num_children || 0,
        },
        folioEntries: [],
        taxes: [],
        balanceDue: parseFloat(booking.balance_amount) || 0,
        isComplimentary: booking.is_complimentary || false,
        taxIncluded: booking.tax_included || false,
        additionalNotes: booking.additional_notes || "N/A",
        additionalGuests: booking.additional_guests || [],
        marketCode: booking.market_code || "N/A",
        corporateCompanyName: booking.corporate_company_name || "N/A"
      };

      const paymentSummary = {
        checkInDate: format(normalizedCheckIn, 'MMM dd, yyyy'),
        checkOutDate: format(normalizedCheckOut, 'MMM dd, yyyy'),
        roomCharges: parseFloat(booking.total_amount) || 0,
        taxes: 0,
        fees: 0,
        totalAmount: parseFloat(booking.total_amount) || 0,
        paymentMethod: booking.payment_status === "pending" ? "Not Paid" : "Paid",
        transactionId: "N/A",
        status: booking.payment_status,
        advanceAmount: parseFloat(booking.advance_amount) || 0
      };

      setGuestDetails(guestDetails);
      setPaymentSummary(paymentSummary);
    } catch (err) {
      console.error("Error fetching reservation details:", err);
      setError("Failed to load reservation details.");
    } finally {
      setLoading(false);
    }
  };

  if (reservationId) {
    fetchReservationDetails();
  }
}, [reservationId, apiUrl, token]);

useEffect(() => {
  let cancelled = false;
  const fetchRefundCase = async () => {
    if (!reservationId || !apiUrl || !token) return;
    setRefundCaseLoading(true);
    try {
      const params = new URLSearchParams({ pmsBookingId: String(reservationId), page: "1", pageSize: "1" });
      const response = await axios.get(`${apiUrl}/booking/refunds?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!cancelled) setRefundCase(response.data?.refunds?.[0] || null);
    } catch (refundError) {
      // Refund summary is supplementary; do not fail reservation details.
      console.warn("Unable to load refund summary:", refundError?.response?.data?.message || refundError.message);
      if (!cancelled) setRefundCase(null);
    } finally {
      if (!cancelled) setRefundCaseLoading(false);
    }
  };
  fetchRefundCase();
  return () => { cancelled = true; };
}, [reservationId, apiUrl, token]);

const refundMoney = (value, currency = "INR") => {
  if (value == null) return "—";
  const symbols = { INR: "₹", USD: "$", EUR: "€", GBP: "£", AED: "د.إ" };
  const amount = Number(value || 0);
  return `${symbols[currency] || `${currency} `}${amount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const refundStatusLabel = (status) => ({
  calculated: "Calculated",
  pending: "Refund pending",
  processing: "Processing",
  processed: "Refunded",
  manual: "Manually refunded",
  manual_required: "Manual refund required",
  manual_review: "Manual review",
  external_ota: "OTA reconciliation",
  external_reconciled: "OTA reconciled",
  failed: "Refund failed",
  no_refund_required: "No refund required",
}[String(status || "").toLowerCase()] || String(status || "").replace(/_/g, " "));

// Replace the formatDateToYYYYMMDD function


// Inside ReservationGuestDetails component
// Inside ReservationGuestDetails component
// Inside ReservationGuestDetails component
const handleSendEmail = async (type) => {
  // Step 1: Check if guest email exists
  const guestEmail = guestDetails?.email?.trim().toUpperCase() !== "N/A" ? guestDetails.email.trim() : "";
  const guestName = guestDetails?.name || "Guest";
  if (!guestEmail) {
    await Swal.fire({
      title: "Email Missing",
      text: `${guestName} doesn't have an email added. Please add an email address to proceed.`,
      icon: "warning",
      confirmButtonText: "OK",
      confirmButtonColor: "#d33",
    });
    return; // Exit the function if email is missing
  }

  // Step 2: Customize confirmation message based on type
  const emailTypeLabel = type === "invoice" ? "Invoice" : "Portfolio";
  const confirmation = await Swal.fire({
    title: `Send ${emailTypeLabel} Email`,
    text: `Are you sure you want to send the ${emailTypeLabel.toLowerCase()} details email to ${guestEmail}?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, Send",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
  });

  // Step 3: Proceed if confirmed
  if (confirmation.isConfirmed) {
    try {
      const bookingId = guestDetails?.booking_id; // Adjust based on your state structure

      // Debug: Log the bookingId and type to ensure they're correct
      console.log("Booking ID:", bookingId);
      console.log("Type:", type);

      if (!bookingId) {
        throw new Error("Booking ID is missing. Cannot generate invoice.");
      }

      // Step 4: Call generateInvoice directly
      const response = await generateInvoice({ bookingId }, "proforma","email");

      // Debug: Log the response from generateInvoice

      // Step 5: Assume invoiceData contains the generated invoice (e.g., PDF blob or URL)
      // Now send the email with the invoice data
      const apiUrl = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");


      // Step 6: Show success result
      await Swal.fire({
        title: `${emailTypeLabel} Email Sent`,
        text: response || `${emailTypeLabel} email sent successfully to ${guestEmail}!`,
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
      });
    } catch (error) {
      // Debug: Log the error for troubleshooting
      console.error("Error in handleSendEmail:", error);

      // Step 7: Show error result
      await Swal.fire({
        title: "Error",
        text: error.message || `Failed to send ${emailTypeLabel.toLowerCase()} email to ${guestEmail}. Please try again.`,
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#d33",
      });
    }
  }
};


  if (loading) return <p>Loading reservation details...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

    // Handle File Selection
    const handleFileChange = (event) => {
      setSelectedFile(URL.createObjectURL(event.target.files[0]));
    };

  const grandTotalWords = `₹${guestDetails.balanceDue.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
  })}`;


  const handleCheckOut = async () => {
    Swal.fire({
      title: `Proceed with Check-out?`,
      text: `Do you want to check out ${guestDetails?.name}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Check-out!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
  
      try {
        Swal.fire({
          title: "Processing Check-out...",
          text: "Please wait...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
  
        const requestData = {
          bookingId: guestDetails?.booking_id,
          guestName: guestDetails?.name,
          phone: guestDetails?.phone,
          email: guestDetails?.email,
          nationality: guestDetails?.nationality,
          checkInDate: guestDetails?.checkIn,
          roomNumber: guestDetails?.roomNumber,
          roomType: guestDetails?.roomType,
          nights: guestDetails?.nights,
          reservationType: guestDetails?.reservationType,
          bookingSource: guestDetails?.bookingSource,
        };
  
        const response = await axios.post(
          `${apiUrl}/booking/guest-checkout`,
          requestData,
          { headers: { Authorization: `Bearer ${token}` } }
        );
  
        if (response.status === 200) {
          Swal.close();
          setGuestDetails((prev) => ({
            ...prev,
            bookingStatus: "checked_out",
          }));
  
          setPreviewLoading(true);
          setShowModal(true);
  
          const outputType = "html"; // Define the output type explicitly
          const result = await generateInvoice(response.data.invoice.invoice_id, "invoice", "preview", outputType);
  
          if (outputType === "html") {
            // If output type is HTML, set htmlContent and clear pdfUrl
            setHtmlContent(result);
            if (pdfUrl) {
              URL.revokeObjectURL(pdfUrl);
            }
            setPdfUrl("");
          } else {
            // If output type is PDF, handle as Blob
            if (!(result instanceof Blob)) {
              throw new Error("Generated invoice is not a valid Blob.");
            }
            const generatedPdfUrl = URL.createObjectURL(result);
            setPdfUrl(generatedPdfUrl);
            setHtmlContent(null);
          }
  
          setOutputType(outputType); // Set the correct output type
        } else {
          throw new Error("Unexpected response from API");
        }
      } catch (error) {
        console.error("Check-out Error:", error);
        Swal.fire({
          title: "Check-out Failed!",
          text: error.response?.data?.message || "An error occurred during check-out.",
          icon: "error",
        });
      } finally {
        setPreviewLoading(false);
      }
    });
  };
  


// In GuestCheckInOut.js

// Handle popup submission (common for both popups)

const handlePopupSubmit = (data, type) => {
  if (type === "move-room") {
    const { newRoomNos } = data;

    // Update guestDetails with the new room numbers
    setGuestDetails((prev) => {
      return {
        ...prev,
        roomNumber: newRoomNos.join(", "),
      };
    });
  } else if (type === "upgrade-room") {
    const { newRoomNos, newRoomTypes } = data;
    setGuestDetails((prev) => {
      return {
        ...prev,
        roomNumber: newRoomNos.join(", "),
        roomType: newRoomTypes.join(", "),
      };
    });
  } else if (type === "checkout") {
    const { newCheckInDate, newCheckoutDate } = data;

    // Convert the ISO string dates to Date objects for calculation
    const normalizedCheckIn = startOfDay(new Date(newCheckInDate));
    const normalizedCheckOut = startOfDay(new Date(newCheckoutDate));
    const updatedNights = differenceInDays(normalizedCheckOut, normalizedCheckIn);

    // Update guestDetails with new check-in, check-out dates, and recalculate nights
    setGuestDetails((prev) => {
      return {
        ...prev,
        checkIn: newCheckInDate,
        checkOut: newCheckoutDate,
        nights: updatedNights,
      };
    });
  } else if (type === "guest-info") {
    // Handle guest info update (e.g., update guest and booking details)
    const { guest, booking } = data;
    const full_name = guest.full_name;
    // Update guestDetails with the new guest and booking information
    setGuestDetails((prev) => {
      return {
        ...prev,
        name: full_name,
        email: guest.email,
        phone: guest.phone_no,
        arrivalTime :booking.expected_time,	
        expected_time: booking.expected_time ?? prev.expected_time,
        additional_notes: booking.additional_notes ?? prev.additional_notes,
        visit_purpose: booking.visit_purpose ?? prev.visit_purpose,
        arrival_from: booking.arrival_from ?? prev.arrival_from,
        travelling_with_pet:
          typeof booking.travelling_with_pet === "boolean"
            ? booking.travelling_with_pet
            : prev.travelling_with_pet,
        booking: {
          ...booking,
          roomNumber: prev.roomNumber || booking.roomNumber || null,
        },
      };
    });
  }

  setFolioRefreshKey((prev) => prev + 1);
};


// Replace the formatDateToYYYYMMDD function
const formatDateToYYYYMMDD = (dateString) => {
  return dateString ? format(startOfDay(new Date(dateString)), 'yyyy-MM-dd') : '';
};

// Determine dropdown item enablement/disablement based on bookingStatus
const bookingStatus = guestDetails?.bookingStatus;
  const isReserved = bookingStatus === "reserved";
  const isCheckedIn = bookingStatus === "checked_in";
  const isCheckedOutOrCancelledOrNoShow = ["checked_out", "cancelled", "noshow"].includes(bookingStatus);
  const isCheckedOutOperation = ["checked_in", "cancelled", "reserved", "noshow"].includes(bookingStatus);
  const isCancelled= ["cancelled"].includes(bookingStatus);

  const isCheckoutToday = guestDetails?.bookingStatus === "checked_in" && 
  formatDateToYYYYMMDD(guestDetails?.checkOut) === formatDateToYYYYMMDD(business_date);
  
  const showMarkNoShow = bookingStatus === "reserved";
  const showRemoveNoShow = bookingStatus === "noshow";
  const isCheckedOut = bookingStatus === "checked_out";

const isActionEnabled = isReserved || isCheckedIn;
  

  

  const handleCheckIn = async () => {
    Swal.fire({
      title: `Proceed with Check-in?`,
      text: `Do you want to check-in ${guestDetails?.name}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Check-in!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Show loading while processing
          Swal.fire({
            title: "Processing Check-in...",
            text: "Please wait...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
  
          // ✅ Send Complete Data for Check-in
          const requestData = {
            bookingId: guestDetails?.booking_id,
            guestName: guestDetails?.name,
            phone: guestDetails?.phone,
            email: guestDetails?.email,
            nationality: guestDetails?.nationality,
            checkInDate: guestDetails?.checkIn,
            roomNumber: guestDetails?.roomNumber,
            roomType: guestDetails?.roomType,
            nights: guestDetails?.nights,
            reservationType: guestDetails?.reservationType,
            bookingSource: guestDetails?.bookingSource,
          };
  
          // ✅ Call Check-in API with All Data
          const response = await axios.post(
            `${apiUrl}/booking/guest-checkin`,
            requestData,
            { headers: { Authorization: `Bearer ${token}` } }
          );
  
          if (response.status === 200) {
            Swal.fire({
              title: "Check-in Successful!",
              text: `${guestDetails?.name} is now checked in.`,
              icon: "success",
            }).then(() => {
            // Update the guestDetails state to reflect the cancelled status
            setGuestDetails((prev) => ({
              ...prev,
              bookingStatus: "checked_in", // Update the booking status to "cancelled"
            }));

            });
          } else {
            throw new Error("Unexpected response status");
          }
        } catch (error) {
          console.error("Check-in Error:", error);
          Swal.fire({
            title: "Check-in Failed!",
            text: error.response?.data?.message || "An error occurred during check-in.",
            icon: "error",
          });
        }
      }
    });
  };
  
  
	const handlePrintConfirmation = debounce(async (initialOutputType = "html") => {
	  try {
		const bookingId = guestDetails?.booking_id;
		if (!bookingId) {
		  throw new Error("Booking ID is required to generate Reservation Confirmation.");
		}
  
		setPreviewLoading(true);
		setShowConfModal(true);
  
		const result = await generateConfirmation(bookingId, "preview", initialOutputType);
  
		if (initialOutputType === "html") {
		  setConfHtmlContent(result);
		  if (pdfUrl) {
			URL.revokeObjectURL(pdfUrl);
		  }
		  setPdfUrl("");
		} else {
		  if (!(result instanceof Blob)) {
			throw new Error("Generated Reservation Confirmation is not a valid Blob.");
		  }
		  const generatedPdfUrl = URL.createObjectURL(result);
		  setPdfUrl(generatedPdfUrl);
		  setConfHtmlContent(null);
		}
  
		setConfOutputType(initialOutputType);
	  } catch (error) {
		console.error("Reservation Confirmation Error:", error);
		Swal.fire({
		  title: "Error Generating Reservation Confirmation!",
		  text: error.message || "An error occurred while generating the Reservation Confirmation.",
		  icon: "error",
		});
		setShowConfModal(false);
	  } finally {
		setPreviewLoading(false);
	  }
	}, 300);
  
	const handleSwitchConfirmationView = async (newOutputType) => {
	  try {
		setPreviewLoading(true);
		const bookingId = guestDetails?.booking_id;
		if (!bookingId) {
		  throw new Error("Booking ID is required to switch Confirmation Card view.");
		}
  
		const result = await generateConfirmation(bookingId, "preview", newOutputType);
  
		if (newOutputType === "html") {
		  setConfHtmlContent(result);
		  if (pdfUrl) {
			URL.revokeObjectURL(pdfUrl);
		  }
		  setPdfUrl("");
		} else {
		  if (!(result instanceof Blob)) {
			throw new Error("Generated Confirmation Card is not a valid Blob.");
		  }
		  const generatedPdfUrl = URL.createObjectURL(result);
		  setPdfUrl(generatedPdfUrl);
		  setConfHtmlContent(null);
		}
  
		setConfOutputType(newOutputType);
		//toast.success(`Switched to ${newOutputType.toUpperCase()} view!`, { autoClose: 2000 });
	  } catch (error) {
		console.error("Error switching confirmation card view:", error);
		Swal.fire({
		  title: "Error Switching View!",
		  text: error.message || "An error occurred while switching the view.",
		  icon: "error",
		});
	  } finally {
		setPreviewLoading(false);
	  }
	};
  
	const handleEmailConfirmation = async () => {
	  try {
		const bookingId = guestDetails?.booking_id;
		if (!bookingId) {
		  throw new Error("Booking ID is required to email Confirmation Card.");
		}
  
		const result = await generateConfirmation(bookingId, "email");
		return result;
	  } catch (error) {
		console.error("Error emailing confirmation card:", error);
		throw new Error(error.message || "Failed to email the Confirmation Card.");
	  }
	};
  
	const handleCloseConfModal = () => {
	  setShowConfModal(false);
	  if (pdfUrl) {
		URL.revokeObjectURL(pdfUrl);
		setPdfUrl("");
	  }
	  setConfHtmlContent(null);
	};

  const formatMoney = (value) =>
    `₹${Number(value || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  const cleanContextValue = (value, fallback = "Not captured") => {
    const normalized = String(value ?? "").trim();
    if (!normalized || normalized.toUpperCase() === "N/A") return fallback;
    return normalized;
  };

  const previousStayCount = Number(guestDetails?.previous_stays || 0);
  const isRepeatGuest = previousStayCount > 0;
  const guestHistoryLabel = isRepeatGuest
    ? `${previousStayCount} prior completed stay${previousStayCount === 1 ? "" : "s"}`
    : "First completed stay not yet recorded";
  const lastStayLabel =
    isRepeatGuest && guestDetails?.last_stay_date
      ? `Last stay ${renderDate(guestDetails.last_stay_date)}`
      : "";

  const paymentStatus = String(guestDetails?.payment_status || "pending").toLowerCase();
  const paymentStatusLabel =
    paymentStatus === "paid"
      ? "Paid"
      : paymentStatus === "partial"
      ? "Partially Paid"
      : "Balance Due";
  const paymentStatusTone =
    paymentStatus === "paid"
      ? { background: "#ecfdf3", color: "#027a48", border: "#abefc6" }
      : paymentStatus === "partial"
      ? { background: "#fffaeb", color: "#b54708", border: "#fedf89" }
      : { background: "#fef3f2", color: "#b42318", border: "#fecdca" };

  const stayContextItems = [
    {
      label: "Guest history",
      value: isRepeatGuest ? "Repeat Guest" : "First Stay",
      meta: [guestHistoryLabel, lastStayLabel].filter(Boolean).join(" · "),
      icon: <RefreshCw size={15} />,
      accent: isRepeatGuest ? "#027a48" : "#175cd3",
    },
    {
      label: "Booking source",
      value: getPartnerName(guestDetails?.bookingSource) || cleanContextValue(guestDetails?.bookingSource),
      meta: "Acquisition channel",
      icon: <Tag size={15} />,
      accent: "#6941c6",
    },
    {
      label: "Purpose of stay",
      value: cleanContextValue(guestDetails?.visit_purpose),
      meta: "Guest intent",
      icon: <UserCheck size={15} />,
      accent: "#0e7090",
    },
    {
      label: "Travelling from",
      value: cleanContextValue(guestDetails?.arrival_from),
      meta: "Origin / previous location",
      icon: <MapPin size={15} />,
      accent: "#b54708",
    },
    {
      label: "Travelling with pet",
      value:
        guestDetails?.travelling_with_pet === true
          ? "Yes"
          : guestDetails?.travelling_with_pet === false
          ? "No"
          : "Not captured",
      meta: "Reservation-specific",
      icon: <Heart size={15} />,
      accent: guestDetails?.travelling_with_pet === true ? "#c11574" : "#475467",
    },
    {
      label: "Payment position",
      value: paymentStatusLabel,
      meta: `${formatMoney(guestDetails?.total_paid)} paid · ${formatMoney(guestDetails?.balance_due)} due`,
      icon: <CreditCard size={15} />,
      accent: paymentStatusTone.color,
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        {/* Header Section */}
        <div className="page-header page-top-icons">
          <div className="row align-items-center">
            <div className="col-md-6">
              <p className="text-muted">
                <h3>Res No : <strong>{guestDetails.bookingNumber}</strong></h3>
              </p>
            </div>
            <div className="col-md-6 text-end">
              <div
                className="d-flex justify-content-end align-items-center"
                style={{
                  gap: "10px",
                  flexWrap: "nowrap",
                  minHeight: "40px",
                }}
              >

              <Dropdown>
              <Dropdown.Toggle
  variant="primary"
  id="dropdown-edit-reservation"
  className="d-inline-flex align-items-center justify-content-center"
  style={{ height: 40, whiteSpace: "nowrap", padding: "0 16px", fontWeight: 600 }}
>
  <Edit size={16} className="me-2" />
  Edit Reservation
</Dropdown.Toggle>

  <Dropdown.Menu>
    <Dropdown.Header>Reservation Details</Dropdown.Header>
    <Dropdown.Item
      data-bs-toggle="modal"
      data-bs-target="#update_guest_info"
      disabled={isCancelled}
    >
      <User size={16} className="me-2" />
      Edit Guest Details
    </Dropdown.Item>
    <Dropdown.Item
      data-bs-toggle="modal"
      data-bs-target="#update_checkout"
      disabled={isCheckedOutOrCancelledOrNoShow}
    >
      <Calendar size={16} className="me-2" />
      Update Check-In / Check-Out
    </Dropdown.Item>
    <Dropdown.Item
      data-bs-toggle="modal"
      data-bs-target="#update_guest_count"
      onClick={() => setIsOpenUpdate(true)}

      disabled={isCheckedOutOrCancelledOrNoShow}
    >
      <Users size={16} className="me-2" />
      Adjust Guest Count (PAX)
    </Dropdown.Item>
   

    <Dropdown.Divider />

    <Dropdown.Header>Room Actions</Dropdown.Header>

    <Dropdown.Item
    
    data-bs-toggle="modal"
    data-bs-target="#booking_details_popup"
    onClick={() => setIsOpenUpdate(true)}
    disabled={isCheckedOutOrCancelledOrNoShow}
    
    >
      <Edit size={16} className="me-2" />
      Update Room Rates
    </Dropdown.Item>
    
    <Dropdown.Item
      data-bs-toggle="modal"
      data-bs-target="#move_room"
      onClick={() => setIsPopupOpen(true)}
      disabled={isCheckedOutOrCancelledOrNoShow}
    >
      <Move size={16} className="me-2" />
      Move Room (Same Type)
    </Dropdown.Item>

    <Dropdown.Item
       data-bs-toggle="modal"
       data-bs-target="#move_room_all"
       onClick={() => setIsPopupOpen(true)}
       disabled={isCheckedOutOrCancelledOrNoShow}
      >
    <Home size={16} className="me-2"/>   
     Upgrade/Downgrade Room
    </Dropdown.Item>



    <Dropdown.Divider />

    {showMarkNoShow && (
      <Dropdown.Item 
        onClick={(e) => {
          e.preventDefault();
          handleMarkNoShow();
        }}
      >
        <XCircle size={16} className="me-2" />
        Mark No Show
      </Dropdown.Item>
    )}
    {showRemoveNoShow && (
      <Dropdown.Item 
        data-bs-toggle="modal" 
        data-bs-target="#remove_no_show" 
        onClick={handleRemoveNoShow}
      >
        <CheckCircle size={16} className="me-2" />
        Restore Booking
      </Dropdown.Item>
    )}
<Dropdown.Item 
  className="text-danger"
  style={{
    fontSize: "14px",
    color: ["checked_in", "checked_out", "noshow", "cancelled"].includes(guestDetails?.bookingStatus)
      ? "rgba(110, 84, 87, 0.5)" // faded red for disabled
      : "#dc3545",               // normal red for active
    pointerEvents: ["checked_in", "checked_out", "noshow", "cancelled"].includes(guestDetails?.bookingStatus)
      ? "none"
      : "auto",
    cursor: ["checked_in", "checked_out", "noshow", "cancelled"].includes(guestDetails?.bookingStatus)
      ? "not-allowed"
      : "pointer"
  }}
  onClick={(e) => {
    e.preventDefault();
    handleDeleteReservation();
  }}
>
  <AlertCircle size={16} className="me-2" />
  Cancel Reservation
</Dropdown.Item>

  </Dropdown.Menu>
</Dropdown>
   

              {/* 1️⃣ Check-in Button (Only when guest is due today & still Reserved) */}
  {guestDetails?.bookingStatus === "reserved" &&
    formatDateToYYYYMMDD(guestDetails?.checkIn) === formatDateToYYYYMMDD(business_date) && (
<button
  className="btn btn-primary d-inline-flex align-items-center justify-content-center"
  onClick={handleCheckIn}
  style={{
    height: 40,
    minWidth: 148,
    padding: "0 16px",
    whiteSpace: "nowrap",
    lineHeight: 1,
    fontWeight: 600,
    flexShrink: 0,
  }}
>
  <LogIn size={16} className="me-2" />
  Proceed to Check-in
</button>
  )}





{/* Reservation Type (Formatted: "Tentative Booking") - Only for Reserved Guests */}
{guestDetails?.bookingStatus === "reserved" && guestDetails?.reservationType && (


 <span
   className="status-checkedout d-inline-flex align-items-center justify-content-center"
   style={{ height: 40, padding: "0 12px", whiteSpace: "nowrap", flexShrink: 0 }}
 >
   {guestDetails?.reservationType.charAt(0).toUpperCase() + guestDetails?.reservationType.slice(1)}
 </span>

)}

{guestDetails?.bookingStatus === "noshow" && guestDetails?.reservationType && (

<span
  className="status-checkedout d-inline-flex align-items-center justify-content-center"
  style={{ height: 40, padding: "0 12px", whiteSpace: "nowrap", flexShrink: 0 }}
>
  No Show
</span>
)}


{/* 3️⃣ Checkout Button (Only when guest is checked-in and checkout date matches business_date) */}
{guestDetails?.bookingStatus === "checked_in" && 
              formatDateToYYYYMMDD(guestDetails?.checkOut) === formatDateToYYYYMMDD(business_date) && (
        <button
          className="btn btn-danger d-inline-flex align-items-center justify-content-center"
          onClick={handleCheckOut}
          style={{ height: 40, padding: "0 16px", whiteSpace: "nowrap", fontWeight: 600, flexShrink: 0 }}
        >
  <i className="fas fa-sign-out-alt me-2"></i>
  Checkout Guest
</button>
            )}

  {/* 4️⃣ If Guest is Checked-out or Cancelled, Show Static Status */}
 
  {(guestDetails?.bookingStatus === "checkedout" || 
  guestDetails?.bookingStatus === "cancelled") && (
    <div>
      {guestDetails?.bookingStatus === "checkedout" ? (
        <span className="status-checkedout">Guest Checked-Out</span>
      ) : (
        <span className="status-cancelled">Cancelled Booking</span>
      )}
    </div>
)}

  {/* 5️⃣ In-House Badge (For Checked-in Guests) */}
  {guestDetails?.bookingStatus === "checked_in" && (
<span
  className="status-checkedout d-inline-flex align-items-center justify-content-center"
  style={{ height: 40, padding: "0 12px", whiteSpace: "nowrap", flexShrink: 0 }}
>
  <UserCheck size={16} className="me-1" />
  In-House Guest
</span>

  )}

  {/* 5️⃣ In-House Badge (For Checked-in Guests) */}
  {guestDetails?.bookingStatus === "checked_out" && (
   <span
     className="status-cancelled d-inline-flex align-items-center justify-content-center"
     style={{ height: 40, padding: "0 12px", whiteSpace: "nowrap", flexShrink: 0 }}
   >
  <LogOut size={16} className="me-1" />
  Checked Out
</span>

  )}

               
<Dropdown>
  <Dropdown.Toggle
    variant="primary"
    id="dropdown-basic"
    className="d-inline-flex align-items-center justify-content-center"
    style={{ height: 40, whiteSpace: "nowrap", padding: "0 16px", fontWeight: 600 }}
  >
    <Sliders size={16} className="me-2" />
    Actions
  </Dropdown.Toggle>

  <Dropdown.Menu>
    {/* Document Management */}
    <Dropdown.Header>Documents</Dropdown.Header>

    <Dropdown.Item 
    
      onClick={() => handleSendEmail("invoice")}
      disabled={isCheckedOutOperation}
    >
      <Mail size={16} className="me-2" />
      Email Invoice

    </Dropdown.Item>
    <Dropdown.Item 
      href="#email-folio" 
      disabled
      
    >
      <Mail size={16} className="me-2" />
      Email Folio
    </Dropdown.Item>

    {/* Printing */}
    <Dropdown.Header>Print</Dropdown.Header>
  <Dropdown.Item 
    href="#print-folio" 
    onClick={(event) => {
      event.preventDefault();
      handlePrintFolio();
    }}
    disabled={isCheckedOutOrCancelledOrNoShow}
  >
    <Printer size={16} className="me-2" />
    Print Folio
  </Dropdown.Item>
    <Dropdown.Item 
      href="#print-proforma" 
      onClick={(event) => {
        event.preventDefault(); // Prevent default link behavior
        handlePrintProformaInvoice();
      }}
      disabled={!isCheckoutToday}

    >
      <Printer size={16} className="me-2" />
      Print Proforma Invoice
    </Dropdown.Item>
    <Dropdown.Item    
      href="#print-confirmation" 
      onClick={(event) => {
        event.preventDefault(); // Prevent default link behavior
        handlePrintConfirmation();
      }}
      disabled={isCheckedOutOrCancelledOrNoShow}
    >
      <Printer size={16} className="me-2" />
      Print Confirmation
    </Dropdown.Item>
    <Dropdown.Item 
      href="#print-registration" 

      onClick={(event) => {
        event.preventDefault(); // Prevent default link behavior
        handlePrintRegistrationCard();
      }}
      disabled={isCheckedOutOrCancelledOrNoShow}
    >
      <Printer size={16} className="me-2" />
      Print Registration Cards
    </Dropdown.Item>

    {/* Financial Actions */}
    <Dropdown.Header>Financial</Dropdown.Header>
    <Dropdown.Item 
      onClick={handleAddCharge} 
      disabled={isCheckedOutOrCancelledOrNoShow}
    >
      <PlusCircle size={16} className="me-2" />
      Add Charge
    </Dropdown.Item>
    <Dropdown.Item 
      onClick={handleAddPayment} 
      disabled={isCheckedOutOrCancelledOrNoShow}
    >
      <DollarSign size={16} className="me-2" />
      Add Payment
    </Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>

              </div>
            </div>
          </div>
        </div>

        {/* Summary Section */}

        <div className="card mb-4 shadow-sm">
  <div className="card-body form-bg" style={{ minHeight: "0px" }}>
    <div className="row">
      {/* First Row: Guest Details */}
      <div className="col-md-3 profile-item">
        <h6><i className="fas fa-user"></i> Guest Name:</h6> 
        <span>{guestDetails?.name || "N/A"}</span>
      </div>
      <div className="col-md-3 profile-item">
        <h6><i className="fas fa-phone"></i> Phone:</h6> 
        <span>{guestDetails?.phone || "N/A"}</span>
      </div>
      <div className="col-md-3 profile-item">
        <h6><i className="fas fa-envelope"></i> Email:</h6> 
        <span>{guestDetails?.email || "N/A"}</span>
      </div>
      <div className="col-md-3 profile-item">
        <h6><i className="fas fa-calendar-day"></i> Reservation Date:</h6> 

        <span>{guestDetails?.reservationDate ? renderDate(guestDetails.reservationDate) : "N/A"}</span>
      </div>

      {/* Second Row: Booking & Room Details */}
      <div className="col-md-3 profile-item">
        <h6><i className="fas fa-calendar-alt"></i> Check-In:</h6> 
     
        <span>{guestDetails?.checkIn ? renderDate(guestDetails.checkIn) : "N/A"}</span>
      </div>
      <div className="col-md-3 profile-item">
        <h6><i className="fas fa-calendar-check"></i> Check-Out:</h6> 

        <span>{guestDetails?.checkOut ? renderDate(guestDetails.checkOut) : "N/A"}</span>
      </div>

  <div className="col-md-3 profile-item">
    {guestDetails?.bookingStatus != "reserved" ? (
      <>
        <h6><i className="fas fa-users"></i> PAX:</h6>
        <span>{guestDetails?.guests?.adults || 0} / {guestDetails?.guests?.children || 0}</span>
      </>
    ) : (
      <>
        <h6><i className="fas fa-clock"></i> Expected Arrival Time:</h6>
        <span>{guestDetails?.arrivalTime || "N/A"}</span>
      </>
    )}
  </div>

      <div className="col-md-3 profile-item">
        <h6><i className="fas fa-hotel"></i> Reservation Source:</h6> 
        <span>{getPartnerName(guestDetails?.bookingSource) || "N/A"}</span>
      </div>

      {/* Third Row: Room & Payment Details */}
      <div className="col-md-3 profile-item">
        <h6><i className="fas fa-bed"></i> Room Number:</h6> 
        <span>{guestDetails?.roomNumber || "N/A"}</span>
      </div>
      <div className="col-md-3 profile-item">
        <h6><i className="fas fa-th-large"></i> Room Type:</h6> 
        <span>{guestDetails?.roomType || "N/A"}</span>
      </div>
      <div className="col-md-3 profile-item">
        <h6><i className="fas fa-moon"></i> Nights:</h6> 
        <span>{guestDetails?.nights || 0}</span>
      </div>
      <div className="col-md-3 profile-item">
        <h6><i className="fas fa-wallet"></i> Balance Due:</h6> 
        <span className="text-danger balance-due">
          ₹{guestDetails?.balance_due 
            ? parseFloat(guestDetails.balance_due) !== 0 
              ? parseFloat(guestDetails.balance_due).toFixed(2) 
              : "0.00" 
            : "0.00"}
        </span>
      </div>
    </div>
  </div>
</div>

<div
  className="card mb-4"
  style={{
    border: "1px solid #e4e7ec",
    borderRadius: 16,
    boxShadow: "0 10px 30px rgba(16, 24, 40, 0.06)",
    overflow: "hidden",
  }}
>
  <div className="card-body" style={{ padding: 0, background: "#ffffff" }}>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 16,
        padding: "15px 18px",
        borderBottom: "1px solid #eef2f6",
        background: "linear-gradient(135deg, #f8fbff 0%, #ffffff 70%)",
      }}
    >
      <div>
        <div style={{ fontSize: 14, fontWeight: 800, color: "#101828" }}>
          Stay Context
        </div>
        <div style={{ marginTop: 3, fontSize: 11, color: "#667085" }}>
          Guest intelligence and booking signals for front-desk action.
        </div>
      </div>
      <button
        type="button"
        className="btn btn-sm btn-light"
        data-bs-toggle="modal"
        data-bs-target="#update_guest_info"
        disabled={isCancelled}
        style={{
          border: "1px solid #d0d5dd",
          borderRadius: 8,
          fontSize: 11,
          fontWeight: 700,
          color: "#344054",
          padding: "6px 10px",
        }}
      >
        <Edit size={13} className="me-1" />
        Edit stay context
      </button>
    </div>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
        gap: 0,
      }}
    >
      {stayContextItems.map((item, index) => (
        <div
          key={item.label}
          style={{
            minHeight: 108,
            padding: "16px 18px",
            borderRight: "1px solid #f0f2f5",
            borderBottom: "1px solid #f0f2f5",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 7,
              color: item.accent,
              fontSize: 10,
              fontWeight: 800,
              textTransform: "uppercase",
              letterSpacing: ".06em",
            }}
          >
            {item.icon}
            {item.label}
          </div>

          {item.label === "Payment position" ? (
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                marginTop: 10,
                padding: "4px 9px",
                borderRadius: 999,
                border: `1px solid ${paymentStatusTone.border}`,
                background: paymentStatusTone.background,
                color: paymentStatusTone.color,
                fontSize: 11,
                fontWeight: 800,
              }}
            >
              {item.value}
            </div>
          ) : item.label === "Guest history" ? (
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                marginTop: 10,
                padding: "4px 9px",
                borderRadius: 999,
                border: `1px solid ${isRepeatGuest ? "#abefc6" : "#b2ddff"}`,
                background: isRepeatGuest ? "#ecfdf3" : "#eff8ff",
                color: isRepeatGuest ? "#027a48" : "#175cd3",
                fontSize: 11,
                fontWeight: 800,
              }}
            >
              {item.value}
            </div>
          ) : (
            <div
              style={{
                marginTop: 9,
                color: "#101828",
                fontSize: 14,
                fontWeight: 750,
                lineHeight: 1.35,
              }}
            >
              {item.value}
            </div>
          )}

          <div
            style={{
              marginTop: 7,
              color: "#667085",
              fontSize: 10.5,
              lineHeight: 1.4,
            }}
          >
            {item.meta}
          </div>
        </div>
      ))}
    </div>

    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: 10,
        padding: "14px 18px 16px",
        background: "#fcfcfd",
      }}
    >
      <div
        style={{
          width: 30,
          height: 30,
          borderRadius: 9,
          flexShrink: 0,
          display: "grid",
          placeItems: "center",
          background: "#f4f3ff",
          color: "#5925dc",
        }}
      >
        <MessageSquare size={14} />
      </div>
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            fontSize: 10,
            fontWeight: 800,
            color: "#667085",
            textTransform: "uppercase",
            letterSpacing: ".06em",
          }}
        >
          Special Request
        </div>
        <div
          style={{
            marginTop: 4,
            color: "#344054",
            fontSize: 12,
            lineHeight: 1.55,
            whiteSpace: "pre-wrap",
          }}
        >
          {cleanContextValue(guestDetails?.additional_notes, "No special request recorded")}
        </div>
      </div>
    </div>
  </div>
</div>

{(refundCase || refundCaseLoading) && (
  <div className="card mb-4" style={{ border: "1px solid #e6ebf1", borderRadius: 14, boxShadow: "0 4px 14px rgba(15,23,42,.04)", overflow: "hidden" }}>
    <div className="card-body" style={{ padding: 0 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16, padding: "14px 16px", borderBottom: "1px solid #eef2f7", background: "#fbfcfe" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 34, height: 34, borderRadius: 10, background: "#eff6ff", color: "#2563eb", display: "grid", placeItems: "center" }}><DollarSign size={17} /></div>
          <div>
            <div style={{ fontSize: 12, fontWeight: 800, color: "#0f172a" }}>Refund & Reconciliation</div>
            <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 2 }}>{refundCase?.refund_number || "Loading refund case…"}</div>
          </div>
        </div>
        {refundCase && (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ padding: "4px 9px", borderRadius: 999, fontSize: 10, fontWeight: 800, background: refundCase.needs_attention ? "#fffbeb" : "#ecfdf5", color: refundCase.needs_attention ? "#92400e" : "#047857", border: `1px solid ${refundCase.needs_attention ? "#fde68a" : "#a7f3d0"}` }}>
              {refundStatusLabel(refundCase.refund_status)}
            </span>
            <Link to="/hospitality/refunds" style={{ fontSize: 11, fontWeight: 700, color: "#2563eb" }}>Open reconciliation</Link>
          </div>
        )}
      </div>
      {refundCaseLoading && !refundCase ? (
        <div style={{ padding: 16, color: "#64748b", fontSize: 12 }}>Loading refund position…</div>
      ) : refundCase ? (
        <>
          {refundCase.needs_attention && (
            <div style={{ margin: "12px 16px 0", display: "flex", alignItems: "flex-start", gap: 8, padding: "9px 11px", borderRadius: 10, background: "#fffbeb", border: "1px solid #fde68a", color: "#92400e", fontSize: 11 }}>
              <AlertCircle size={14} style={{ flexShrink: 0, marginTop: 1 }} />
              <span><strong>{refundCase.attention_reason || "Needs attention"}.</strong>{refundCase.notes ? ` ${refundCase.notes}` : " Review the central refund case before closing the financial follow-up."}</span>
            </div>
          )}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4,minmax(0,1fr))", gap: 0, padding: "12px 16px 14px" }}>
            {[
              ["Collected", refundMoney(refundCase.amount_paid, refundCase.currency)],
              ["Eligible refund", refundMoney(refundCase.eligible_refund_amount, refundCase.currency)],
              ["Actually refunded", refundMoney(refundCase.actual_refund_amount, refundCase.currency)],
              ["Refund owner", String(refundCase.refund_owner || "property").replace(/_/g, " ")],
            ].map(([label, value], index) => (
              <div key={label} style={{ padding: "4px 14px", borderLeft: index ? "1px solid #eef2f7" : "none" }}>
                <div style={{ fontSize: 9, fontWeight: 800, color: "#94a3b8", textTransform: "uppercase", letterSpacing: ".07em" }}>{label}</div>
                <div style={{ fontSize: 13, fontWeight: 800, color: label === "Actually refunded" && Number(refundCase.actual_refund_amount || 0) > 0 ? "#047857" : "#0f172a", marginTop: 5, textTransform: label === "Refund owner" ? "capitalize" : "none" }}>{value}</div>
              </div>
            ))}
          </div>
        </>
      ) : null}
    </div>
  </div>
)}

<div className="card-body form-bg-">

<Tabs
      id="guest-tabs"
      activeKey={key}
      onSelect={handleTabSelect} // Updated handler
      className="mb-4"
    >
      {/* Accommodation Details Tab */}
      <Tab
        eventKey="accommodationDetails"
        title={
          <span>
            <Home size={18} className="me-2" /> Accommodation Details
          </span>
        }
      >
        <Suspense fallback={<Loader />}>
          <GuestAccommodationDetails reservationId={reservationId} />
        </Suspense>
      </Tab>

      {/* Folio Tab */}
      <Tab
        eventKey="folio"
        title={
          <span>
            <FileText size={18} className="me-2" /> Folio
          </span>
        }
      >
        <Suspense fallback={<Loader />}>
          <GuestFolio
            reservationId={reservationId}
            key={folioRefreshKey}
            onBalanceDueUpdate={handleBalanceDueUpdate}
          />
        </Suspense>
      </Tab>

      {/* Guest Details Tab */}
      <Tab
        eventKey="guestDetails"
        title={
          <span>
            <User size={18} className="me-2" /> Guest Details
          </span>
        }
      >
        <Suspense fallback={<Loader />}>
          <GuestDetails
            reservationId={reservationId}
            guestDetails={guestDetails}
            setGuestDetails={setGuestDetails}
            selectedFile={selectedFile}
            handleFileChange={handleFileChange}
          />
        </Suspense>
      </Tab>

      {/* Activity Details Tab */}
      <Tab
        eventKey="activityDetails"
        title={
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <Logs size={18} style={{ marginRight: '8px' }} />
          Activity Logs
        </span>
      </div>
        }
      >
        <Suspense fallback={<Loader />}>
          <GuestActivityHistory
            reservationId={reservationId}
            refreshKey={activityRefreshKey}
          />
        </Suspense>
      </Tab>
    </Tabs>
       
</div>

{/* Include the InvoicePreview component */}
<InvoicePreview
          showModal={showModal}
          onClose={handleCloseProformaModal}
          pdfUrl={pdfUrl}
          htmlContent={htmlContent}
          guestDetails={guestDetails}
          type="proforma"
          outputType={outputType}
          handleSwitchView={handleSwitchView}
          loading={previewLoading}
        />
{showAddPayment && (
          <AddPaymentPopup
            onSubmit={(data) => handlePaymentSubmit(data)} // Updated to use handlePopupSubmit
            bookingId={guestDetails?.booking_id}
            paymentData={null} // Pass existing payment data if editing, otherwise null
            onCancel={() => setShowAddPayment(false)}
            isVisible={showAddPayment}

          />
        )}


{showAddCharge && (
          <AddChargePopup
            onSubmit={(data) => handleChargeSubmit(data)} // Updated to call handleChargeSubmit with charge data
            bookingId={guestDetails?.booking_id}
            onCancel={() => setShowAddCharge(false)}
            isVisible={showAddCharge}
          />
        )}

<UpdateCheckoutPopup
bookingId={guestDetails?.booking_id}
onSubmit={(data) => handlePopupSubmit(data, "checkout")}
bookingData={guestDetails}
/>


<UpdateGuestInfoPopup
 bookingId={guestDetails?.booking_id}
  onSubmit={(data) =>  handlePopupSubmit(data, "guest-info")}
  bookingData={guestDetails}
/>
   
<UpdateGuestCountPopup
isOpenUpdate={isOpenUpdate}
bookingId={guestDetails?.booking_id}
onSubmit={(data) => handlePopupSubmit(data, "pax")}
bookingData={guestDetails}
onClose={() => setIsOpenUpdate(false)}

/>   

<MoveRoomPopup
isOpen={isPopupOpen}
bookingId={guestDetails?.booking_id}
onSubmit={(data) => handlePopupSubmit(data, "move-room")}
onClose={() => setIsPopupOpen(false)}
bookingData={guestDetails}
/> 

<MoveRoomPopupAll
isOpen={isPopupOpen}
bookingId={guestDetails?.booking_id}
onSubmit={(data) => handlePopupSubmit(data, "upgrade-room")}
onClose={() => setIsPopupOpen(false)}
bookingData={guestDetails}
/> 

<BookingPriceUpdatePopup
isOpenUpdate={isOpenUpdate}
bookingId={guestDetails?.booking_id}
onSubmit={(data) => handlePopupSubmit(data, "")}
onClose={() => setIsOpenUpdate(false)}
bookingData={guestDetails}
/> 

<RegistrationCardPreview
          showModal={showRegModal}
          onClose={handleCloseRegModal}
          pdfUrl={pdfUrl}
          htmlContent={regHtmlContent}
          guestDetails={guestDetails}
          type="registration-card"
          outputType={regOutputType}
          handleSwitchView={handleSwitchRegistrationCardView}
          handleEmail={handleEmailRegistrationCard}
          loading={previewLoading}
        />
        <RegistrationCardPreview
          showModal={showConfModal}
          onClose={handleCloseConfModal}
          pdfUrl={pdfUrl}
          htmlContent={confHtmlContent}
          guestDetails={guestDetails}
          type="confirmation-card"
          outputType={confOutputType}
          handleSwitchView={handleSwitchConfirmationView}
          handleEmail={handleEmailConfirmation}
          loading={previewLoading}
        />
<FolioPreview
        showModal={showFolioModal}
        onClose={handleCloseFolioModal}
        reservationId={guestDetails?.booking_id}
        guestDetails={guestDetails}
        onBalanceDueUpdate={() => {}}
        outputType={folioOutputType}
        handleSwitchView={handleSwitchFolioView}
        handleEmail={handleEmailFolio}
        loading={false} // Pass loading state if needed from parent
      />
        {/* Tabs Section */}
        {/* Actions */}
  
      </div>
      
    </div>

  );
};

export default GuestCheckInOut;
